// extracted by mini-css-extract-plugin
export default {"badge":"ItodcIK0Tuc9lbijVtkd__badge___","hidden":"PTuNsin36MAoY6ftQAfs__hidden___"};